export default {
  personalDetails: 'Personal details',
  workExperience: 'Work experience',
  preference: 'Preference',
  viewFile: 'Your uploaded file',
  jobProfile: 'Job Profile',
  fields: {
    name: 'Full Name *',
    gender: 'What is your gender? *',
    qualification: 'What is your highest qualification? *',
    specialisation: 'What is your specialisation?',
    resume: 'Do you have a resume?',
    experience: 'How long were you working *',
    pastEmployer: 'Your past employer?',
    designation: 'Your recent designation?',
    salary: 'Your recent salary?',
    jobCategory: 'What kind of job are you looking for *',
    preferredLocation: 'Your preferred location? *',
    jobType: 'Your preferred job type *',
    workType: 'Your preferred work type *',
    shiftTiming: 'Your preferred work time *'
  },
  uploadResume: 'Upload your resume',
  uploadText: 'You can upload a .jpg, .pdf or a word doc. OR take a picture',
  optional: 'Optional',
  placeholders: {
    name: 'Provide your full name for recruiters',
    specialisation: 'eg: Engineering, Arts',
    pastEmployer: 'eg: TCS, Wipro',
    designation: 'eg: Sales Manager',
    salary: 'Choose a salary range',
    jobCategory: 'Choose job categories',
    preferredLocation: 'Select multiple districts',
    searchForJobs: 'Search for jobs',
    signUp: 'Signup'
  },
  buttons: {
    uploadResume: 'Upload resume',
    capture: 'Take a picture',
    uploadFromDevice: 'Upload from device',
    next: 'Next',
    submit: 'Submit',
    done: 'Done',
    viewFile: 'View File',
    delete: 'Delete',
    change: 'Change',
    pause: 'Pause',
    retry: 'Retry'
  },
  allStates: 'Anywhere in {state}',
  jobCategory: 'Job Category',
  preferredLocation: 'Preferred Location',
  salary: 'Choose Salary Range',
  resume: 'Resume',
  recommendedJobs: 'Recommended jobs',
  sponsoredJobs: 'Sponsored jobs',
  footerFields: {
    CustomerServices: 'Customer Services',
    emailUs: 'Email us',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and conditions',
    needJob: 'Need a job near you?',
    jobs: '1 lakh jobs',
    sections: '40 sections'
  },
  emptyResultsScreenFields: {
    jobsByCategories: 'Jobs by Categories',
    jobsByLocation: 'Jobs by Location',
    headerMessage1: 'Sorry, we could not find any open roles for your search',
    headerMessage2: 'Signup for Job alerts and we’ll notify you when new jobs have opened up',
    explore: 'Explore jobs by categories and location',
    noOfJobs: '10 jobs',
    icon: 'icon'
  },
  exploreJobsFiltersFields: {
    Category: 'Category',
    salaryRange: 'Salary Range',
    Experience: 'Experience',
    exploreJobsHero: 'Explore by job categories'
  },
  faqFields: {
    header: 'Frequently asked questions'
  },
  homePageHeroFields: {
    findDreamJob: 'Find your dream job!',
    availableJobsAndNoOfCities: ' 50 Lakh+ Jobs | 70+ Cities',
    content: 'Apply for jobs on Lokalapp & talk to the HRs of the companies directly.'
  },
  appalyForJob: 'Apply for a Job',
  searchJob: 'Search job',
  postAJob: 'Post A job',
  jobFindingStepsFields: {
    step1: '1. Create your job Profile',
    step2: '2. Find a job vacancy',
    step3: '3. Contact the HR directly to Apply',
    hero: 'Find your dream job using Lokal in 3 simple steps:'
  },
  jobSearchPlaceHolder: 'Search for jobs',
  share: 'Share',
  shareOnWhatsApp: 'Share on WhatsApp',
  report: 'Report',
  viewJobs: 'View jobs',
  lookingForJobHero: {
    hero: 'Looking for a job?',
    content: 'The sky was cloudless and had a deep blue hue.'
  },
  postNewJobFields: {
    hero: 'Post your work Local application in 3 simple steps:',
    content1: 'Target job advertising from 250+ districts',
    content2: 'Recruit from 1 lakh eligible candidates',
    content3: 'Get maximum responses at low rates'
  },
  quickAccessFooterFields: {
    quickLinks: 'Quick Links',
    categoryWiseJobs: 'Jobs by category',
    jobsByLocation: 'Jobs by location',
    viewAllCategories: 'View all categories',
    viewAllLocations: 'View all locations'
  },
  jobSearchPlaceHolder1: 'Enter Job title, keyword,...',
  warangal: 'warangal',
  krishna: 'krishna',
  vishakapatnam: 'Vishakapatnam',
  yadadri: 'yadadri',
  guntur: 'guntur',
  jobs: 'Jobs',
  seeAll: 'See all',
  jobListing: 'Job Listing',
  findAJob: 'Find a job',
  createAnAccount: 'Create an account',
  jobSearchAdvice: 'Job Search Advice',
  administration: 'Administration',
  digitalMarketing: 'Digital Marketing',
  design: 'Design',
  development: 'Development',
  productmanagement: 'Product management',
  finance: 'Finance',
  agra: 'Agra',
  bengaluru: 'Bengaluru',
  delhi: 'Delhi',
  mumbai: 'Mumbai',
  hi: 'Hi',
  home: 'Home',
  exploreJobs: 'Explore Jobs',
  postAJob: 'Post a Job',
  contactUs: 'Contact Us',
  contact: 'contact',
  getTheApp: 'Get the App',
  loginOrCreateAnAccount: 'Login or Create an account',
  login: 'Login',
  createYourProfile: 'Create profile',
  editProfile: 'Edit Profile',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  disclosureTitle: {
    jobDetails: 'Job Details',
    feesRequired: 'Fees Required',
    noFeeIsRequired: 'No fee is required'
  },
  whyIsItNeeded: 'Why is it needed',
  emailUsOn: 'email us on',
  similarJobs: 'Similar Jobs',
  noSimilarJobs: 'No similar Jobs',
  loading: 'Loading',
  enterNewMobileNumber: 'Enter new mobile number',
  mobileNumber: 'Mobile Number',
  anOtpWillBeSentToThisNumber: 'An OTP will be sent to this number',
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  noResultsFoundFor: 'No results found for',
  jobsTitle: 'Jobs in {location} | Find Job Vacancies in {location} : {host}/jobs',
  jobsMetaData:
    'Apply for Jobs in {location} on {host}/jobs. Register for Free & Find Job Openings in {location}',
  posted: 'Posted',
  ago: 'ago',
  views: 'views',
  cancel: ' cancel',
  pleaseTryAgain: 'Please try again',
  locationsNotAvailable: 'Locations not available',
  jobsByCategories: 'Jobs by category',
  footerModelForApplyJobFields: {
    header1: 'Are you sure want to continue',
    header2: 'Job Application has been succesfully Submitted',
    applyConformation: 'applying for this job?',
    subText1: 'if selected,you will receive a call from the recuiter',
    subText2: 'Your details will be sent to the recruiter'
  },
  advertiser: {
    whatOurUsersSay: 'What our employers have to say about Lokal'
  },
  searchJobs: 'Search Jobs',
  createFreeAccount: 'Create free account',
  jobAdvice: 'Job Advice',
  postAJob: 'Post a Job',
  mobileNumber: 'Mobile Number',
  sendOTP: 'Send OTP',
  verifyOTP: 'Verify OTP',
  downLoadApp: 'Download the app',
  jobsNearMeTitle: '{numberOfJobs} Job Openings & Vacancies  - Find the Perfect Job',
  jobsDescription:
    'Searching for jobs in {Location}? Find the latest openings and vacancies in {Location} in 2023 with Lokal Job Listings',
  postJobSteps: {
    jobDetail: 'Job details',
    aboutJob: 'About the Job',
    selectRole: 'Select Job Role',
    selectTitle: 'Select Job title',
    postTitle: 'Enter post title',
    sampleJobTypes: 'E.g. Sales Accountant, Delivery Boy etc',
    addJobDescription: 'Add job description',
    removeJobDescription: ' Remove job description',
    NoOfOpenings: 'Number of openings',
    enterNoOfOpenings: 'Enter number of openings',
    monthlyIncome: 'Monthly income',
    enterMinSalary: 'Enter min salary',
    enterMaxSalary: 'Enter max salary',
    jobShift: 'Job shift',
    dayShift: 'Day shift',
    nightShift: 'Night shift',
    anyShift: 'Any shift',
    jobType: 'Job type',
    fieldJob: 'Filed Job', //field
    officeJob: 'Office Job',
    workFromHome: 'Work from home',
    industryJob: 'Industry Job',
    officeLocation: 'Office location',
    interstedPlace: 'Where are you interested in hiring from?',
    district: 'District',
    selectMultipleDistricts: 'Select multiple districts',
    charges: 'For this job, will you charge any fee from candidates',
    yes: 'Yes',
    no: 'No',
    reasonForFee: 'Kindly ensure that fee is collected for genuine reasons and inform the candidate clearly the reason for fee',
    feeAmount: 'Fee amount (in rupees)',
    selectReasonsForFee: 'Select reasons for fee',
    registrationFee: 'Registration Fee',
    trainingFee: 'Training fee',
    feeForOtherReasons: 'Fee for uniforms, equipment, tools etc.',
    securityDeposit: 'Security deposit',
    commission: 'Commission',
    otherReason: 'Other reason',
    specifyOtherReason: 'specify other reason (if any)',
    feeDueDate: 'When should the fee be paid',
    afterGivingJob: 'After giving job',
    beforeGivingJob: 'Before giving job',
    candidateRequirement: 'Candidate requirements',
    candidateQualification: 'Candidate qualification',
    candidateRequirement: 'Candidate Requirement',
    selectMinimumEducation: 'Select minimum education',
    selectYourExperience: 'Select years of experience',
    preferredGender: 'Preferred gender',
    male: 'Male',
    female: 'Female',
    anyGender: 'Any Gender',
    contactCandidatesThrough: 'Manage candidates through',
    callOnWhatsapp: 'Calls and Whatsapp',
    callOnly: 'Calls only',
    whatsappNo: 'Same number as whatsapp',
    next: 'Next',
    back: 'Back',
    companyDetail: 'Company details',
    selectCompanyType: 'Select your company type',
    consultancy: 'Consultancy / Manpower firm',
    hiresThirdPartyCompany: 'I hire for third party companies',
    company: 'Company',
    hireForMyComapny: 'I hire for my company / store',
    company: 'Company',
    companyname: 'Enter company name',
    companySize: 'Company size',
    largeScale: 'Large-scale [50+ employees]',
    midScale: 'Mid-scale [20-50 employees]',
    smallScale: 'Small-scale [5-20 employees]',
    companyNameToBeDisplayed: 'Company name to be displayed to candidates for this job',
    consultancyName: 'Consultancy name',
    otherThirdPartyname: 'Other third-party company name',
    jobDescriptionPlaceholder: 'What will be the employees’ responsibilities?',
    officeLocationCityPlaceholder: 'Search city / town',
    officeLocationAreaPlaceholder: 'Search locality / area',
    noOptionsDropdown: 'Type for options',
    selectDistrict: 'Select District',
    selectDistricts: 'Select Districts',
    noDistrictSelected: 'selected',
    whatsappNumber: 'WhatsApp Number',
    recruiterLogin: 'You are logged in as a recruiter from',
    advertiserTooltip: 'This name will be displayed as the hiring company to the candidates who view this job.',
    consultancyManpowerFirm: 'Consultancy / Manpower firm',
    thirdPartyHire: 'I hire for third party companies',
    companyNew: 'Company',
    companyStore: 'I hire for my company / store',
    consultancyNameNew: 'Enter consultancy name',
    choosePlan: 'Choose plan',
    noFeeWarning: 'Kindly ensure that no fee is collected. Lokal app holds the right to remove job posts or block advertisers/companies that fraud candidates.',
    feePaidQuestion: 'When should the fee be paid? (Optional)',
    feePaidCaution: 'Lokal app holds the right to remove job posts or block advertisers/companies that fraud candidates.',
    useCurrentLocation: 'use current location',
    skillsRequired: 'Skills required',
    addOtherSkills: 'Add other skills',
    additionalSkills: 'Additional skills',
    additionalSkillsMsg: 'You can add a maximum of 3 additional skills',
    additionalSkillsPlaceholder: 'Add other skills separated by comma',
    perDistrictChargeOne: 'You will be charged',
    perDistrictChargeTwo: 'per district basis',
    perDistrictChargeThree: 'if you buy a paid plan.',
    skillsSelectedPlaceholder: 'skills selected',
    industryLocation: 'Industry location',
    fieldLocation: 'Field location',
    workFromHome: 'Registered office address',
    submit: 'Submit',
    newFeeWarning: 'Kindly ensure that no fee is collected. If found fradulent, Lokal app holds the right to remove your job posts without issuing a refund.',
    tncOne: 'Read full',
    tncTwo: 'terms & conditions',
    tncThree: '',
    courseTitle: 'Select Course/Certificate',
    minEducation: 'Minimum Education',
    selectCoursePlaceholder: 'Select Course Name',
    courseName: 'Course name',
    optional: 'optional',
    experience: 'Experience',
    postingLocationMessage: 'You will receive candidates from',
    postingLocationModalTitle: 'Select hiring location',
    postingLocationSearchPlaceHolder: 'Search cities',
    proceedToPaySubtext: 'We follow fair use and privacy rules. Breaking policies or fraud can lead to account suspension and loss of service fees.',
    checkout: 'Checkout',
    checkoutInfo: 'Review your order and proceed with payment to unlock your benefits.',
    orderSummary: 'Order Summary',
    proceedToPay: 'Proceed to Pay',
    discount: 'Discount',
    subTotal: 'Sub Total',
    gst: 'GST',
    totalBill: 'Your Total Bill',
    gstinfo:'The prices are inclusive of GST',
    pay: 'Pay',
    verified: 'Verified',
    companyEmail: 'Company Email',
    enterCompanyEmail: 'Enter Company Email',
    profileDetails: 'Profile details'
  },
  postJobErrorStates: {
    noOptions: 'Please select an option',
    wrongValue: 'Please enter correct value',
    noOpenings: 'Please specify number of openings',
    noMonthlySalary: 'Please provide monthly salary',
    lowMinSalary: 'Please ensure min salary is not below 1000',
    highMinSalary: 'Minimum monthly salary must be less than Rs. 1,00,000',
    noFeeAmount: 'Please enter Fee amount (in ₹)',
    lowMaxSalary: 'Please ensure max salary is not below 1000',
    highMaxSalary: 'Maximum monthly salary must be less than Rs. 1,00,000',
    minGreaterMax: 'Maximum salary must be greater than minimum salary',
    noTextArea: 'Please fill the text area',
    noPhoneNumber: 'Please enter phone number',
    noConsultancyName: 'Please enter consultancy name',
    noCompanyName: 'Please enter company name',
    noCompanyType: 'Please select your company type',
    noDataFound: 'No Data Found',
    emailNoSpaces: 'Email cannot contain spaces.',
    emailMaxLength: 'Email is too long. Maximum 320 characters allowed.',
    duplicateEmail: 'This email is already in use. Please enter a different email.',
    invalidEmail: 'Please enter a valid email address (e.g., user@example.com).',
    duplicateEmail: 'This email is already in use. Please enter a different email.'
  },
  payments: {
    paymentHistory: 'Payment History',
    orderId: 'Order ID',
    planDetail: 'Plan detail',
  },
  editRepost: 'Edit & Repost',
  completePosting: 'Complete Posting',
  repostMessage: 'Repost now to make this post live',
  paymentMessage: 'Complete payment to make your job live'
}
